import logger from 'utils/logger';

export const getTextContentsFromHtmlString = (html) => {
  const el = document.createElement('div');
  el.innerHTML = html;
  return el.textContent;
};

export const copyToClipboard = async (value) => {
  try {
    await navigator.clipboard.writeText(value);
  } catch (error) {
    // Fallback to the older method if Clipboard API fails
    logger.error('Error copying to clipboard', error);
    const $textarea = document.createElement('textarea');
    $textarea.value = value;
    document.body.appendChild($textarea);
    $textarea.select();
    document.execCommand('copy');
    document.body.removeChild($textarea);
  }
};

export const isFocusedElementEditable = () =>
  !!document.activeElement.getAttribute('contenteditable') ||
  ['TEXTAREA', 'INPUT'].includes(document.activeElement.tagName);
